module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Anna")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Solch schönes Gefäß, solch süßer Wein"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsoll zerfallen und ungetrunken sein?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ein Auge, so rein wie Sternenlicht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nnicht soll es erleuchten und wärmen nicht?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und irren doch rings in der Welt umher"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nviel Seelen so licht- und so wärmeleer,")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("die sich sehnen so sehr nach der Liebe\nStrahl,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder sich nie durch die Nacht ihres Lebens stahl.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Solch süßer Leib, solch schwellende Brust"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsoll nie erblühen in Liebeslust?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Solch wilde Kraft austoben nie"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nals in kranken Phantomen der Phantasie?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page22",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Solch stolzer Bau auf ewig vergehn,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nnicht im Erben einmal wieder auferstehn?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tauschönes Bild, ich sog deinen Duft,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nso leicht wie der gleitende Atem der Luft,")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("umgaukelte dich, ein Falter blau,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch strich ich dir ab kein Tröpflein Tau.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Du duftest und stehest noch taufrisch im\nHain,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch der Winter bricht mit den Frösten herein.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Frühtau gefriert, der Dufthauch erstirbt,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund der Tod um die liebliche Blume wirbt.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0